import jwt from 'jsonwebtoken';
import { USER_ROLES } from '../constants/user';

export default {
  getUserAuthToken() {
    return localStorage.getItem('user-token');
  },
  getUserInfo() {
    return jwt.decode(localStorage.getItem('user-token'));
  },
  getUserBrokerId() {
    const userInfo = this.getUserInfo();
    return userInfo ? userInfo.id_regional : null;
  },
  getUserConsultancyId() {
    const userInfo = this.getUserInfo();
    return userInfo ? userInfo.id_divisao : null;
  },
  getUserCovenanceId() {
    const userInfo = this.getUserInfo();
    return userInfo ? userInfo.id_convenio : null;
  },
  getUserRole() {
    if (this.getUserBrokerId()) {
      return USER_ROLES.BROKER;
    }
    if (this.getUserConsultancyId()) {
      return USER_ROLES.CONSULTANCY;
    }
    if (this.getUserCovenanceId()) {
      return USER_ROLES.COVENANCE;
    }
  },
};
